import { KeyValuePair, UserInfo, DisplayUnits, LazyUserInfo } from "../../../models";
import { DEFAULT_NAVIGATION_SENSITIVITY } from "../../Constants";
import { IMedia } from "../../models/Models";
import { DataStoreTable } from "./DataStoreTable";
import { DataProviderArgs } from "../../DataStore/DataProvider";
import { cloneDeep, groupBy, orderBy } from "lodash-es";

export enum DistanceUnit {
    Meters = "meters",
    Feet = "feet",
}

export enum TemperatureUnit {
    Celsius = "celsius",
    Fahrenheit = "fahrenheit",
}

export type IKeyValuePair = {
    key: string;
    value: string;
};

export type IUserSocials = {
    facebook?: string;
    x?: string;
    blueSky?: string;
    instagram?: string;
    website?: string;
};

export function makeEmptyUserSocials() {
    return {
        facebook: undefined,
        x: undefined,
        blueSky: undefined,
        instagram: undefined,
        website: undefined,
    } as IUserSocials;
}

export type IUserInfo = {
    id: string;
    owner?: string | null;
    avatar?: IMedia | null;
    banner?: IMedia | null;
    bio?: string | null;
    socials?: IUserSocials | null;
    displayName?: string | null;
    navigationAccuracy?: number | null;
    displayUnits?: DisplayUnits | keyof typeof DisplayUnits | null;
    createdAt?: string | null;
};

export const DEFAULT_USER_INFO = {
    avatar: undefined,
    displayName: undefined,
    displayUnits: DisplayUnits.BOTH,
    navigationAccuracy: DEFAULT_NAVIGATION_SENSITIVITY,
} as IUserInfo;

export function awsToSimpleKeyPair(pair: KeyValuePair): IKeyValuePair {
    return {
        key: pair.key,
        value: pair.value,
    };
}

export function awsToSimpleUser(aws: UserInfo | LazyUserInfo | IUserInfo): IUserInfo {
    return {
        id: aws.id,
        owner: aws.owner,
        bio: aws.bio,
        avatar: cloneDeep(aws.avatar),
        banner: cloneDeep(aws.banner),
        socials: aws.socials ? (cloneDeep(aws.socials) as IUserSocials) : makeEmptyUserSocials(),
        displayName: aws.displayName,
        displayUnits: aws.displayUnits,
        navigationAccuracy: aws.navigationAccuracy,
        createdAt: aws.createdAt,
    };
}

/**
 * The user table is special in that each user can only have a single record. IF it does
 * not exist it will get created
 */
export class UserTable extends DataStoreTable<IUserInfo> {
    constructor(args: DataProviderArgs) {
        super(args, "user", UserInfo, (obj: any) => awsToSimpleUser(obj));
    }

    protected override _optimisticUpdateItem(_item: any) {
        //TODO: disabled for now
    }

    public async removeDuplicates() {
        const all = Array.from(await this.all());

        const byOwner = groupBy(all, (x: IUserInfo) => x.owner);
        for (const u of Object.keys(byOwner)) {
            let objs = byOwner[u];
            objs = orderBy(objs, ["createdAt"], ["desc"]);
            if (objs.length > 1) {
                for (let i = 0; i < objs.length - 1; ++i) {
                    await this.delete(objs[i].id);
                }
            }
            console.log(`Fixed ${objs[0].id} : ${objs.length}`);
        }
    }
}
